import styled from "styled-components";
import { StyledCheckbox } from "../../components/InputArea/Checkbox";
import React from "react";
import CustomModal from "../../components/CustomModal";
import { useCurrency } from "../../hooks/useCurrency";
import { CustomAutoCompleteInput } from "../../components/InputArea/AutoCompleteInput";
import CustomLabel from "../../components/InputArea/CustomLabel";
import { CustomButton } from "../../components/Button/CustomButton";
import { FieldArray, Formik } from "formik";
import { ActionButtonPropInterface } from "./contents";
import { currencyList } from "./data";

interface TransactionSettingsProps {
  ActionButtons: ActionButtonPropInterface;
}
export const TransactionSettings: React.FC<TransactionSettingsProps> = ({
  ActionButtons,
}) => {
  const [openCurrencyModal, setOpenCurrencyModal] = React.useState(false);
  const { data: currencies, isLoading, error } = useCurrency();
  const toggleCurrencyModal = () => {
    setOpenCurrencyModal(!openCurrencyModal);
  };
  const cancelCurrencyData = (handleChange?: any) => {
    handleChange("newCurrency", "");
    setOpenCurrencyModal(false);
  };

  return (
    <SettingsList
      initialValues={{
        currencies: [{ code: "USD", name: "US Dollar", selected: true }],
        newCurrency: "",
      }}
      onSubmit={async (input, { setSubmitting }) => {
        console.log({ input });
        setSubmitting(false);
      }}
    >
      {({
        setFieldValue,
        handleSubmit,
        handleReset,
        values,
        isValid,
        errors,
        isSubmitting,
        initialTouched,
      }) => {
        const addToCurrencyArray = async () => {
          if (!values.newCurrency) return;
          await setFieldValue(`currencies.${values.currencies.length}`, {
            ...values.newCurrency,
            selected: true,
          });
          await setFieldValue("newCurrency", "");
          toggleCurrencyModal();
        };
        console.log({ isValid, isSubmitting, errors });
        return (
          <>
            <SettingsItem>
              <div className={"title"}>
                <h3>Currency Settings</h3>
                <p>Add your preferred currency to make receive payment</p>
              </div>
              <div className={"content"}>
                <FieldArray
                  name={"currencies"}
                  render={(helper) => (
                    <>
                      {values.currencies?.map(
                        (currency: any, index: number) => (
                          <div
                            key={currency.name}
                            className={"selected-currency"}
                          >
                            <StyledCheckbox
                              onClick={({ target }: any) => {
                                helper.replace(index, {
                                  ...currency,
                                  selected: target.checked,
                                });
                              }}
                              checked={currency.selected}
                            />
                            <strong>{currency.code}</strong> {currency.name}
                          </div>
                        )
                      )}
                    </>
                  )}
                />
                {!isLoading && !error && currencies?.list && (
                  <span className={"link"} onClick={toggleCurrencyModal}>
                    Add currency
                  </span>
                )}
              </div>
            </SettingsItem>
            {currencies?.list && (
              <CustomModal
                header={{
                  title: "Add Currency",
                  subtitle: "Add more than one currency to receive payment",
                }}
                open={openCurrencyModal}
                onClose={toggleCurrencyModal}
              >
                <div>
                  <CustomLabel>Currency</CustomLabel>
                  <br />
                  <br />
                  <CustomAutoCompleteInput
                    id={"transaction-currency-search-box"}
                    options={currencyList as any}
                    placeholder={"Select Currency"}
                    onSelected={(item: any) =>
                      setFieldValue("newCurrency", item)
                    }
                  />
                </div>
                <br />
                <br />
                <ModalButtons>
                  <CustomButton
                    $outline
                    $gray
                    onClick={() => cancelCurrencyData(setFieldValue)}
                    id={"cancel-add-currency"}
                  >
                    Cancel
                  </CustomButton>
                  <CustomButton
                    style={{ width: 100 }}
                    disabled={!values.newCurrency}
                    $secondary
                    id={"save-add-currency"}
                    onClick={addToCurrencyArray}
                  >
                    Add
                  </CustomButton>
                </ModalButtons>

                <br />
              </CustomModal>
            )}

            {ActionButtons(handleReset, handleSubmit, {
              values,
              isValid: isValid && !isSubmitting,
              isSubmitting,
            })}
          </>
        );
      }}
    </SettingsList>
  );
};

const SettingsList = styled(Formik)``;
const SettingsItem = styled.div`
  display: flex;
  justify-content: space-evenly;
  > div.title {
    flex: 0.7;
    padding-right: 15px;
  }
  > div.content {
    flex: 1;
    .selected-currency {
      color: #5e5e5e;
      font-family: "GT Walsheim Pro";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.28px;
      display: flex;
      gap: 10px;
      align-items: center;
      padding-bottom: 20px;
    }
  }
  @media (max-width: 760px) {
    flex-wrap: wrap;
  }
  h3 {
    color: #0e0e0e;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.32px;
    margin: 0;
  }
  a,
  .link {
    color: #008502;
    font-family: "GT Walsheim Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.28px;
    cursor: pointer;
  }
  p {
    color: #868686;
    font-family: "GT Walsheim Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.28px;
  }
`;

const ModalButtons = styled.section`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding-top: 30px;
`;
